/**
 * Marque du cadre (ADR-092, référence « ULTIM APP ») : carré de logo à monogramme et filigrane du
 * fond. Couleurs par jetons seulement : `color.brand.logo` (sinon `color.accent.default`) pour le
 * carré, `color.text.primary` et `shell.monogram_opacity` pour le filigrane.
 */

/** Une lettre de monogramme : l'initiale du tenant, sinon « A ». */
export function monogramLetter(label: string | undefined): string {
  const letter = (label ?? '').trim().match(/\p{L}/u)?.[0];
  return (letter ?? 'A').toUpperCase();
}

export function BrandMark({ label }: { label: string | undefined }) {
  return (
    <span className="ay-brandmark" aria-hidden="true">
      <span className="ay-brandmark__letter">{monogramLetter(label)}</span>
    </span>
  );
}

/** Filigrane géométrique (écusson hexagonal et initiale), décoratif. */
export function Monogram({ label }: { label: string | undefined }) {
  return (
    <svg className="ay-monogram" viewBox="0 0 200 200" aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="0.8">
        <path d="M100 8 L172 50 L172 134 L100 176 L28 134 L28 50 Z" />
        <path d="M100 22 L160 56 L160 124 L100 158 L40 124 L40 56 Z" />
      </g>
      <text x="100" y="122" textAnchor="middle" className="ay-monogram__letter" fill="currentColor">
        {monogramLetter(label)}
      </text>
    </svg>
  );
}
